// extracted by css-extract-rspack-plugin
export default {"selectorButton":"EnvironmentPicker-module__selectorButton__sXg8B"};